module.exports = {
    CXF_DIALOG_OPEN: 'cxf.dialog.open',
    CXF_DIALOG_CLOSE: 'cxf.dialog.close'
}
